// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EventHeader_wrapper__lK1a- global_content-pad__14Cxg","imagewrapper":"EventHeader_imagewrapper__2iXit","h2":"EventHeader_h2__2Bz2g"};